import { render, staticRenderFns } from "./CreateBotForm.vue?vue&type=template&id=cd0f19ca&scoped=true&"
import script from "./CreateBotForm.vue?vue&type=script&lang=js&"
export * from "./CreateBotForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateBotForm.vue?vue&type=style&index=0&id=cd0f19ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd0f19ca",
  null
  
)

export default component.exports